import AGREGAR_CONTRATO_FIANZA from '@/graphql/mutations/administracion/contratos/contrato/fianzas/agregarContratoFianza.gql';
import ACTUALIZAR_CONTRATO_FIANZA from '@/graphql/mutations/administracion/contratos/contrato/fianzas/actualizarContratoFianza.gql';
import REMOVER_CONTRATO_FIANZA from '@/graphql/mutations/administracion/contratos/contrato/fianzas/removerContratoFianza.gql';
import CONTRATO_FIANZAS from '@/graphql/querys/administracion/contratos/fianzas/contratoFianzas.gql';

export const TIPOS_FIANZA = [
  { id: 1, nombre: 'Cumplimiento' },
  { id: 2, nombre: 'Anticipo' },
  { id: 3, nombre: 'Vicios ocultos' },
  { id: 4, nombre: 'Endoso' },
];

export default {
  methods: {
    // Agregar Fianza
    async mixAgergarFianza() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_FIANZA,
          variables: {
            fianza: this.fianza,
          },
          update: (store, { data: { agregarContratoFianza } }) => {
            const query = {
              query: CONTRATO_FIANZAS,
              variables: {
                idContrato: this.contrato.id,
              },
            };
            const { contratoFianzas } = store.readQuery(query);
            const contratoFianzasCopia = contratoFianzas.slice();
            contratoFianzasCopia.push(agregarContratoFianza);
            store.writeQuery({
              ...query,
              data: {
                contratoFianzas: contratoFianzasCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Actualizar Fianza
    async mixActualizarFianza() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_FIANZA,
          variables: {
            id: this.contratoFianzaEditar.id,
            fianza: this.fianza,
          },
          update: (store, { data: { actualizarContratoFianza } }) => {
            const query = {
              query: CONTRATO_FIANZAS,
              variables: {
                idContrato: this.contratoFianzaEditar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoFianzas } = data;
            const index = contratoFianzas
              .findIndex((contratoFianza) => contratoFianza.id
              === actualizarContratoFianza.id);
            if (index !== -1) {
              contratoFianzas.splice(index, 1, actualizarContratoFianza);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Fianza
    async mixEliminarFianza() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_FIANZA,
        variables: {
          id: this.contratoFianzaEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_FIANZAS,
            variables: {
              idContrato: this.contratoFianzaEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoFianzas } = data;
          const index = contratoFianzas
            .findIndex((fianza) => fianza.id === this.contratoFianzaEliminar.id);
          if (index !== -1) {
            contratoFianzas.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
